import {FocusMonitor} from '@angular/cdk/a11y';
import {Platform} from '@angular/cdk/platform';
import {
   Component, ChangeDetectorRef, ChangeDetectionStrategy, Directive, ElementRef,
   HostBinding, HostListener, OnDestroy, ViewEncapsulation, Input
} from '@angular/core';
import {
   CanColor,
   CanDisable,
   CanDisableRipple,
   mixinColor,
   mixinDisabled,
   mixinDisableRipple
} from '@angular/material/core';

@Directive({
   selector: 'button[loading]'
})
export class LoadingButtonCssMatStylerDirective {
   @HostBinding('class.mat-button') _ = true;
}

@Directive({
   selector: 'button[loading-raised]'
})
export class LoadingRaisedButtonCssMatStylerDirective {
   @HostBinding('class.mat-raised-button') _ = true;
}

export class LoadingButtonBase {
   constructor(public _elementRef: ElementRef) {
   }
}

export const _ButtonMixinBase = mixinColor(mixinDisabled(mixinDisableRipple(LoadingButtonBase)));

@Component({
   selector: 'button[loading], button[loading-raised]',
   exportAs: 'loadingButtonComponent',
   templateUrl: 'button.html',
   styleUrls: ['button.css'],
   encapsulation: ViewEncapsulation.None,
   preserveWhitespaces: false,
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingButtonComponent extends _ButtonMixinBase implements OnDestroy, CanDisable, CanColor, CanDisableRipple {
   @HostBinding('class.loading-button') loading: boolean;
   @HostBinding('class.mat-button-disabled') @HostBinding() @Input() disabled;
   @Input() disableRipple;
   @Input() color;

   constructor(elementRef: ElementRef, private _platform: Platform,
               private _focusMonitor: FocusMonitor, private cdRef: ChangeDetectorRef) {
      super(elementRef);
      this._focusMonitor.monitor(elementRef.nativeElement, true);
   }

   @HostListener('click', ['$event'])
   onClick(e: Event) {
      this.busy();
   }

   busy(): void {
      this.loading = true;
      this._elementRef.nativeElement.style.pointerEvents = 'none';
      this.cdRef.detectChanges();
   }

   reset(): void {
      this.loading = false;
      this._elementRef.nativeElement.style.pointerEvents = '';
      this.cdRef.detectChanges();
   }

   ngOnDestroy() {
      this._focusMonitor.stopMonitoring(this._getHostElement());
   }

   focus(): void {
      this._getHostElement().focus();
   }

   _getHostElement() {
      return this._elementRef.nativeElement;
   }

   _isRippleDisabled() {
      return this.disableRipple || this.disabled;
   }

   _hasHostAttributes(...attributes: string[]) {
      // If not on the browser, say that there are none of the attributes present.
      // Since these only affect how the ripple displays (and ripples only happen on the client),
      // detecting these attributes isn't necessary when not on the browser.
      if (!this._platform.isBrowser) {
         return false;
      }

      return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
   }
}
